<template>
  <div v-if="!this.error" id="app-page" class="app-page" :class="brand.name">
    <AppNavigation v-if="!inIframe" v-bind:brand="brand" v-bind:dealer="dealer"></AppNavigation>
    <router-view/>
    <PageFooter v-if="!inIframe" v-bind:brand="brand" v-bind:dealer="dealer"></PageFooter>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AppNavigation from '@/components/AppNavigation'
const PageFooter = () => import('@/components/PageFooter')

export default {
  name: 'AppPage',
  props: {
    inIframe: Boolean
  },
  components: {
    AppNavigation,
    PageFooter
  },
  computed: {
    ...mapState({
      params: state => state.params,
      dealer: state => state.dealer,
      brand: state => state.brand,
      error: state => state.error
    }),
    ...mapGetters({
      ecommEnabled: 'ecommEnabled',
      scheduleEnabled: 'scheduleEnabled'
    })
  },
  methods: {
    initializeOffers () {
      this.$store.dispatch('offer/getOffers')
      if (this.ecommEnabled) {
        this.$store.dispatch('productVariants/getProducts')
      }
    },
    initializeAppointmentOptions () {
      if (this.scheduleEnabled) {
        this.$store.dispatch('appointmentOptions/getSchedule')
      }
    }
  },
  created: function () {
    if (!this.error) {
      // get offers and coupons
      this.initializeOffers()
      // use the jwt to load personalization data
      this.$store.dispatch('customer/getDetails')
      // if query string option is on then call the mutation
      if (this.params && this.params.show_modal === 'true') {
        this.$nextTick(() => { this.$router.replace({ name: 'appointment' }).catch(() => {}) })
      }
    }
  }
}
</script>

<style scoped>
.app-page {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  height: 100%;
  margin: 0;
  max-width: 100%;
  font-family: var(--font-stack);
  color: var(--text-color);
  background-color: #ffffff;
}
@media only screen and (min-width: 576px) {
}

@media only screen and (min-width: 768px) {
}

@media only screen and (min-width: 992px) {
}

@media only screen and (min-width: 1200px) {
}
</style>
